export const htmlContent = (html: string): HTMLElement | string => {
    let tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.innerHTML || html;
};

export const setTagClass = (classProperties: string[] | string) => {
    if (Array.isArray(classProperties)) {
        return classProperties.every((i) => i.length === 0)
            ? ''
            : ` ${classProperties.join(' ').trim()}`;
    } else {
        return classProperties ? ` ${classProperties}` : '';
    }
};

export const setTagStyle = (...styleProperties: string[]) => {
    return styleProperties.every((i) => i.length === 0)
        ? ''
        : ` style="${styleProperties.join(' ').trim()}"`;
};

export const clearTimer = (timer: number | null) => {
    if (timer) clearTimeout(timer);
};

export function removeAllElements<T extends HTMLElement>(
    elements: T[] | undefined
) {
    if (!elements || elements.length === 0) {
        return;
    }

    elements.forEach((element) => {
        element.remove();
    });
}

export const isFunction = (value: unknown): value is Function => {
    return typeof value === 'function';
};
